import { ThemeInterface, themeNames } from "../theme";
import { colors } from "../../styles/variables";
import {
  GATORADE_COLORS,
  GATORADE_SHARED_HEADING_STYLES,
} from "./GatoradeTheme";
import { fontWeights } from "../../types/styles";

export const GatoradeTeamZoneTheme: ThemeInterface = {
  name: themeNames.TeamZone,
  color: {
    primary: GATORADE_COLORS.gatoradeOrange,
    secondary: GATORADE_COLORS.black,
    tertiary: colors.white,
    accent: GATORADE_COLORS.gatoradeOrange,
    disabled: colors.gray300,
    action: colors.green,
    error: colors.red,
    text: GATORADE_COLORS.black,
  },
  typography: {
    body: {
      lineHeight: "1.5",
      color: GATORADE_COLORS.black,
    },
    heading: {
      xxl: {
        fontSize: {
          desktop: "46px",
          mobile: "32px",
        },
        letterSpacing: "-1px",
        ...GATORADE_SHARED_HEADING_STYLES,
      },
      xl: {
        fontSize: {
          desktop: "32px",
          mobile: "24px",
        },
        letterSpacing: "-1px",
        ...GATORADE_SHARED_HEADING_STYLES,
      },
      l: {
        fontSize: {
          desktop: "24px",
          mobile: "20px",
        },
        letterSpacing: "-1px",
        ...GATORADE_SHARED_HEADING_STYLES,
      },
      m: {
        fontSize: {
          desktop: "18px",
          mobile: "18px",
        },
        ...GATORADE_SHARED_HEADING_STYLES,
      },
      s: {
        fontSize: {
          desktop: "16px",
          mobile: "16px",
        },
        ...GATORADE_SHARED_HEADING_STYLES,
      },
      xs: {
        fontSize: {
          desktop: "14px",
          mobile: "14px",
        },
        ...GATORADE_SHARED_HEADING_STYLES,
      },
      xxs: {
        fontSize: {
          desktop: "14px",
          mobile: "14px",
        },
        fontWeight: fontWeights["400"],
      },
    },
  },
  button: {
    primary: {
      color: GATORADE_COLORS.gatoradeOrange,
    },
    secondary: {
      color: colors.green,
    },
    tertiary: {
      color: GATORADE_COLORS.gatoradeOrange,
      hollow: true,
      solidOnHover: true,
    },
    cancel: {
      color: colors.gray600,
      hollow: true,
      solidOnHover: true,
    },
    error: {
      color: colors.red,
      hollow: true,
    },
    text: {
      color: GATORADE_COLORS.gatoradeOrange,
    },
    fontWeight: fontWeights["700"],
  },
  header: {
    fontSize: "14px",
    portal: {
      backgroundColor: GATORADE_COLORS.black,
      mobileLinkColor: colors.white,
      navLinkOpacity: "1",
    },
    shop: {
      backgroundColor: GATORADE_COLORS.black,
      mobileLinkColor: colors.white,
      navLinkHover: {
        backgroundColor: GATORADE_COLORS.black,
        color: colors.white,
      },
    },
    simple: {
      checkout: {
        backgroundColor: GATORADE_COLORS.black,
      },
      portal: {
        backgroundColor: GATORADE_COLORS.black,
      },
    },
  },
  footer: {
    backgroundColor: GATORADE_COLORS.black,
    textColor: colors.gray300,
    copyright: {
      textColor: colors.gray300,
      backgroundColor: GATORADE_COLORS.black,
    },
  },
};
